/* @flow */
import React, { Component } from 'react';
import { graphql } from 'react-relay';
import { CSVLink } from 'react-csv';
import RaisedButton from 'material-ui/RaisedButton';

import RelayStore from '../../relay/RelayStore';
import Well from '../components/Well';
import Loader from '../components/Loader';

type Props = {};

type State = {
  loading: boolean,
  error: ?Error,
  tutors: ?Array<any>,
  students: ?Array<any>,
};

const styles = {
  button: {
    margin: 5,
  },
};

const exportTutorQuery = graphql`
  query AdminExportStudentAdminQuery {
    admin {
      export {
        tutors {
          firstname
          lastname
          status
          email
          createdAt
        }
      }
    }
  }
`;

const exportStudentQuery = graphql`
  query AdminExportTutorAdminQuery {
    admin {
      export {
        students {
          firstname
          lastname
          status
          email
          createdAt
        }
      }
    }
  }
`;

export default class AdminExport extends Component<Props, State> {
  state = {
    loading: false,
    error: null,
    tutors: null,
    students: null,
  };

  handleExportStudents = async () => {
    this.setState({ loading: true, error: null });

    try {
      const { admin } = await RelayStore.fetchQuery(exportStudentQuery);
      this.setState({ students: admin.export.students, loading: false });
    } catch (error) {
      this.setState({ loading: false, error });
    }
  };

  handleExportTutors = async () => {
    this.setState({ loading: true, error: null });

    try {
      const { admin } = await RelayStore.fetchQuery(exportTutorQuery);
      this.setState({ tutors: admin.export.tutors, loading: false });
    } catch (error) {
      this.setState({ loading: false, error });
    }
  };

  render() {
    const { loading, error, students, tutors } = this.state;

    return (
      <Well>
        <h2>Export</h2>

        {loading && <Loader />}
        {error && <div>{error.message}</div>}

        <RaisedButton
          label="Students"
          primary
          style={styles.button}
          disabled={loading}
          onClick={this.handleExportStudents}
        />
        <br />
        {students && (
          <div>
            <CSVLink data={students} filename="student-export.csv">
              Download Students
            </CSVLink>
            <br />
          </div>
        )}
        <RaisedButton
          label="Tutors"
          primary
          style={styles.button}
          disabled={loading}
          onClick={this.handleExportTutors}
        />
        {tutors && (
          <div>
            <CSVLink data={tutors} filename="tutor-export.csv">
              Download Tutors
            </CSVLink>
            <br />
          </div>
        )}
      </Well>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin/AdminExport.js